import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchBulletins = (params) => {
  return apiActionCreator({
    'endpoint': `/bulletin${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_BULLETINS,
      ActionTypes.FETCHED_BULLETINS,
      [
        ActionTypes.FETCHED_BULLETINS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'form',
    'method': 'GET',
  });
};

export const clearBulletinList = () => ({
  'type': ActionTypes.CLEAR_BULLETIN_LIST,
});
